export const subjectIdsByStandard = {
  1: [14, 15, 16, 17],
  2: [16, 17, 18, 19],
  3: [16, 17, 20, 21, 22],
  4: [16, 17, 22, 23, 24, 25],
  5: [16, 17, 22, 23, 27, 28],
};

export const filterSubjectsByStandard = (subjects, standardIndex) => {
  const allowedIds = subjectIdsByStandard[standardIndex];
  if (!allowedIds) return [];

  return subjects.filter((item) =>
    allowedIds.includes(Number(item.id))
  );
};
